import { render, staticRenderFns } from "./edit-infodownload.vue?vue&type=template&id=24ea1994"
import script from "./edit-infodownload.vue?vue&type=script&lang=ts"
export * from "./edit-infodownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports